import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const GMKDarling = () => (
  <ArticleWrapper articleId="gmk_darling">
    <div className="min-h-screen bg-[#111112] flex flex-col w-full">
      <div className="prose prose-invert mx-auto p-6">
        <h1>GMK Darling</h1>
        {/* Add your GMK Darling article content here */}
        <p>This is a placeholder article for the GMK Darling keycap set. More content coming soon.</p>
      </div>
    </div>
  </ArticleWrapper>
);

export default GMKDarling;
